var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-view',{attrs:{"search-columns":_vm.searchColumns},on:{"update:search-values":_vm.updateSearch}},[_c('div',[_c('arquivos-remessa-data-table',{ref:"dataTable",attrs:{"search-values":_vm.searchValues}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }